const $ = jQuery.noConflict();

export default class WineDataBase {
    constructor() {
        this.container = $('.wine-data-base');
        this.searchTrigger = this.container.find('button.submit');
        this.search = this.container.find('input[type="search"]');
        this.selects = this.container.find('select');
        this.sortWrapper = this.container.find('.wines-sort');
        this.sortOptions = this.sortWrapper.find('.options');
        this.sortOptionsTrigger = this.sortWrapper.find('.label');
        this.sortOptionsCurrent = this.sortOptionsTrigger.find('.current-option');
        this.sortOption = this.sortWrapper.find('.option');
        this.pagination = this.container.find('.pagination');
        this.appendWrapper = this.container.find('.wines-results-wrapper');
        this.foundPosts = this.container.find('.wines-count .counter');
        this.scrollTo = this.container.find('.wines-results');
        this.credentials = WineDataBase.createCredentials();
    }


    static createCredentials() {
        let container = $('.wine-data-base');
        let search = container.find('input[type="search"]');
        let pagination = container.find('.pagination');
        let sortWrapper = container.find('.wines-sort');
        let sortOptions = sortWrapper.find('.options');

        return {
            filters: {},
            search: search.val(),
            page: container.attr('data-current-page'),
            ppp: container.data('ppp') || 20,
            order: sortOptions.find('.current').attr('data-order'),
            sort: sortOptions.find('.current').attr('data-sort'),
        };
    }


    configureDropdowns() {
        let Utils = $.fn.select2.amd.require('select2/utils');
        let Dropdown = $.fn.select2.amd.require('select2/dropdown');
        let DropdownSearch = $.fn.select2.amd.require('select2/dropdown/search');
        let CloseOnSelect = $.fn.select2.amd.require('select2/dropdown/closeOnSelect');
        let AttachBody = $.fn.select2.amd.require('select2/dropdown/attachBody');

        let dropdownAdapter = Utils.Decorate(Utils.Decorate(Utils.Decorate(Dropdown, DropdownSearch), CloseOnSelect), AttachBody);

        $('.wine-data-base select.search-taxonomy').select2(
            {
                language: "pl",
                templateResult: function(row) {
                    if(row.loading) {
                        return row.text;
                    }

                    let colorValue = '';

                    if(row.element !== undefined) {
                        colorValue = $(row.element).data('colorvalue');
                    } else {
                        colorValue = row.colorValue;
                    }

                    if ('' === colorValue) {
                        return row.text;
                    }

                    return $('<div><span class="selectColor" style="background-color: '+colorValue + '"></span>' + row.text +'</div>');
                },
                dropdownAdapter: dropdownAdapter,
                minimumResultsForSearch: 0,
                escapeMarkup: function(markup) {
                    return markup;
                },
                ajax: {
                    url: `${WP.apiUrl}wines-filter-search-terms/`,
                    beforeSend: (xhr) => {
                        xhr.setRequestHeader('X-WP-Nonce', WP.apiNonce);
                    },
                    data: function (params) {
                        let processedCredentials = WineDataBase.setFilterTerms();
                        processedCredentials.filter_query = params.term;
                        processedCredentials.selector_key = $(this).attr('id')

                        return processedCredentials;
                    }
                },
            });
    }

    init() {
        WineDataBase.updateSortOption();

        this.configureDropdowns();

        this.searchTrigger.on('click', (e) => {
            e.preventDefault();
            this.apiCall();
        });

        this.sortOptionsTrigger.on('click', () => {
            this.openSortOptions();
        });

        this.sortOption.on('click', (e) => {
            this.changeSortOption($(e.delegateTarget));
            this.apiCall();
        });

        $(document).on('click', '.pagination-button', (e) => {
            e.preventDefault();
            this.changePage($(e.target));
            this.apiCall();
        })
    }

    changeSortOption(element) {
        const order = element.data('order');
        const sort = element.data('sort');

        this.credentials.sort = sort;
        this.credentials.order = order;

        this.sortOption.removeClass('current');
        element.addClass('current');

        WineDataBase.updateSortOption();
        this.closeSortOptions();
    }

    static updateSortOption() {
        let container = $('.wine-data-base');
        let sortWrapper = container.find('.wines-sort');
        let sortOptions = sortWrapper.find('.options');
        let sortOptionsTrigger = sortWrapper.find('.label');
        let sortOptionsCurrent = sortOptionsTrigger.find('.current-option');
        sortOptionsCurrent.html(sortOptions.find('.current').html());
    }

    openSortOptions() {
        let container = $('.wine-data-base');
        let sortWrapper = container.find('.wines-sort');
        let sortOptions = sortWrapper.find('.options');
        sortOptions.addClass('active');
    }

    closeSortOptions() {
        let container = $('.wine-data-base');
        let sortWrapper = container.find('.wines-sort');
        let sortOptions = sortWrapper.find('.options');
        sortOptions.removeClass('active');
    }

    changePage(element) {
        this.credentials.current_page = element.data('page')
        console.log(element.data('page'));
        this.container.attr('data-current-page', element.data('page'))
    }

    static setFilterTerms() {
        let credentials = WineDataBase.createCredentials();
        this.updateSortOption();
        credentials.filters = {};

        $('.wine-data-base select').each((i, e) => {
            const that = $(e);
            const selected = that.find('option:selected');
            if (selected.length) {
                credentials.filters[that.attr('name')] = selected.map((i, e) => $(e).val()).get();
            }
        });

        return credentials
    }

    apiCall() {
        let credentials = WineDataBase.setFilterTerms();

        $.ajax({
            method: 'GET',
            url: `${WP.apiUrl}wines-data-base/`,
            data: credentials,
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce', WP.apiNonce);
            },
            success: (response) => {
                this.foundPosts.text(response.found_posts);
                this.appendWrapper.html(response.content);
                history.pushState(response, 'test', response.url);
                console.log(response)
            },
            fail: (response) => {
                console.log('fail', response);
            },
            complete: () => {
                $('html, body').animate({
                    scrollTop: this.scrollTo.offset().top
                }, 1000);
            }
        });
    }
}
